import React, { useCallback } from 'react';
import { Box, BoxExtendedProps, PencilIcon, Text } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  testId?: string;
  title?: string;
  value?: string;
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
  onChangeValue?: (value: string) => void;
  isSelected?: boolean;
  children: React.ReactNode;
}

const EditableBadge: React.FC<Props> = ({
  testId,
  title,
  value,
  isEditMode,
  setIsEditMode,
  onChangeValue,
  isSelected,
  children,
  ...props
}) => {
  const handleEditMode = useCallback(() => {
    setIsEditMode(true);
  }, [setIsEditMode]);

  const handleSelect = useCallback(() => {
    if (!isSelected) {
      onChangeValue?.(value || '');
    }
  }, [onChangeValue, value, isSelected]);

  if (isEditMode || !value) {
    return children;
  }

  return (
    <Box
      data-testId={`${testId}-editable-badge`}
      direction="row"
      background={isSelected ? 'successContainer' : 'canvas'}
      round="button1Round"
      align="center"
      justify="center"
      border={{ size: 'small', color: isSelected ? 'success' : 'border1' }}
      pad={{ left: 'spacing16', right: 'spacing12', vertical: '10px' }}
      onClick={handleSelect}
      {...props}
    >
      <Text
        data-testId={`${testId}-editable-badge_value`}
        weight={isSelected ? 700 : 400}
        color={isSelected ? 'success' : 'textBody'}
      >
        {title}
      </Text>
      {isSelected ? (
        <Box
          data-testId={`${testId}-editable-badge_edit_button`}
          margin={{ left: 'spacing2' }}
          onClick={handleEditMode}
        >
          <PencilIcon color="success" size="16px" />
        </Box>
      ) : null}
    </Box>
  );
};

export default EditableBadge;
